// Sliding highlight for toggle groups: one indicator moves to whichever button is `.on`.
// Synced after clicks and resizes rather than by observing class changes, which would fire on every ladder update.

const GROUPS = '.p-seg, .wl-seg, .view-row, .chart-types, .chart-ranges';

const sized = new WeakSet<HTMLElement>();
const resize = new ResizeObserver((entries) => {
  for (const e of entries) sync(e.target as HTMLElement, false);
});

export function installSeg(): void {
  // Bubble phase plus a frame, so the app's own click handler has already moved `.on`.
  document.addEventListener('click', (e) => {
    const group = (e.target as HTMLElement | null)?.closest<HTMLElement>(GROUPS);
    if (group) requestAnimationFrame(() => sync(group, true));
  });
  // First hover places the indicator without animating, before any click needs it to slide.
  document.addEventListener('pointerover', (e) => {
    const group = (e.target as HTMLElement | null)?.closest<HTMLElement>(GROUPS);
    if (group && !group.classList.contains('has-ind')) sync(group, false);
  });
}

function sync(group: HTMLElement, animate: boolean): void {
  if (!group.isConnected) return;
  const on = [...group.children].find((c): c is HTMLElement => c instanceof HTMLElement && c.classList.contains('on'));
  let ind = group.querySelector<HTMLElement>(':scope > .seg-ind');
  if (!on || !on.offsetWidth) {
    ind?.remove();
    group.classList.remove('has-ind');
    return;
  }
  if (!ind) {
    ind = document.createElement('i');
    ind.className = 'seg-ind';
    group.prepend(ind);
    animate = false;
  }
  if (!sized.has(group)) {
    sized.add(group);
    resize.observe(group);
  }
  ind.style.transition = animate ? '' : 'none';
  ind.style.width = `${on.offsetWidth}px`;
  ind.style.height = `${on.offsetHeight}px`;
  ind.style.transform = `translate(${on.offsetLeft}px, ${on.offsetTop}px)`;
  group.classList.add('has-ind');
  if (!animate) requestAnimationFrame(() => { if (ind) ind.style.transition = ''; });
}
